import moment from 'moment';

import * as Constants from '../constants/user';

const initialState = {
  loyaltyStatistics: {},
  user: {},
  userActivities: [],
  users: [],
  userAttributes: {
    addressValidated: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };
    case Constants.GET_USERS_BY_URL_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };
    case Constants.GET_USER_SUCCESS:
    case Constants.ANONYMIZE_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loyaltyStatistics: {
          ...state.loyaltyStatistics,
          last_online: moment(action.payload.last_online).format('LL'),
          date_created: moment(action.payload.date_created).format('LL'),
        },
      };
    case Constants.GET_USER_ACTIVITIES_SUCCESS:
      return {
        ...state,
        userActivities: action.payload,
      };
    case Constants.GET_USER_ACTIVITIES_BY_URL_SUCCESS:
      return {
        ...state,
        userActivities: action.payload,
      };

    case Constants.GET_LOYALTY_STATISTICS_REQUEST:
      return {
        ...state,
        isLoadingLoyaltyStatistics: true,
      };
    case Constants.GET_LOYALTY_STATISTICS_SUCCESS:
      return {
        ...state,
        isLoadingLoyaltyStatistics: false,
        loyaltyStatistics: {
          ...state.loyaltyStatistics,
          ...action.payload,
        },
      };
    case Constants.SET_ACTIVE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case Constants.SET_ACTIVE_USER_INFO:
      return {
        ...state,
        loyaltyStatistics: action.payload,
      };
    case Constants.SET_USER_HAS_VALID_ADDRESS:
      return {
        ...state,
        userAttributes: {
          ...state.userAttributes,
          hasValidAddress: action.payload,
        },
      };
    case Constants.SET_USER_HAS_BEEN_VALIDATED:
      return {
        ...state,
        userAttributes: {
          ...state.userAttributes,
          addressValidated: action.payload,
        },
      };
    case Constants.CLEAR_USER_ATTRIBUTES:
      return {
        ...state,
        userAttributes: {
          addressValidated: false,
        },
      };
    default:
      return state;
  }
};
